import React from 'react';
import {defineMessage} from 'react-intl';
import {BuildInstructions} from '../../components/left-col';

export const buildInstructions = [
  {
    label: 'npm',
    body: {
      message: defineMessage({
        id: 'docsApp.ib.aap.snippets.node.npm.body',
        defaultMessage: 'Install the library:',
      }),
    },
    command: 'npm install --save stripe',
    shell: true,
  },
  {
    label: {
      message: defineMessage({
        id: 'docsApp.ib.aap.snippets.node.github.label',
        defaultMessage: 'GitHub',
      }),
    },
    body: {
      message: defineMessage({
        id: 'docsApp.ib.aap.snippets.node.github.body',
        defaultMessage:
          'Or download the stripe-node library source code directly ',
        description:
          'First part of a sentence that ends in docsApp.ib.aap.snippets.node.github.link . Please translate them with this in mind.',
      }),
    },
    link: {
      href: 'https://github.com/stripe/stripe-node',
      label: {
        message: defineMessage({
          id: 'docsApp.ib.aap.snippets.node.github.link',
          defaultMessage: 'from GitHub.',
          description:
            'Second part of a sentence that begins in with docsApp.ib.aap.snippets.node.github.body . Please translate them with this in mind.',
        }),
      },
    },
  },
];

export const setup = {
  heading: {
    message: defineMessage({
      id: 'docsApp.ib.aap.snippets.node.github.install.heading',
      defaultMessage: 'Install the Stripe Node library',
    }),
  },
  body: {
    message: defineMessage({
      id: 'docsApp.ib.aap.snippets.node.github.install.body',
      defaultMessage:
        'Install the package and import it in your code. Alternatively, if you’re starting from scratch and need a <code>package.json</code> file, download the project files using the link in the code editor.',
    }),
    values: {
      code: (str) => <code>{str}</code>,
    },
  },
  Component() {
    return <BuildInstructions instructions={buildInstructions} />;
  },
};

export const run = 'npm start';
